import {TranslatorScope} from '../../../locale/types'

// WBA-4840: POST memberships/:id/payCurrentCycle now answers 409 when no cycle was charged and 402
// when the card was declined (with the provider's message). Before, every one of those was a 200 and
// the customer saw "Success" over an unpaid cycle. The mapping is pure so it can be tested.

export type PayCycleError = {
  key: TranslatorScope
  detail?: string
}

type ErrorLike = {
  response?: {
    status?: number
    data?: unknown
  }
}

const providerMessage = (data: unknown): string | undefined => {
  if (typeof data !== 'object' || data === null || !('paymentError' in data)) {
    return undefined
  }
  const paymentError = (data as {paymentError?: unknown}).paymentError
  if (typeof paymentError !== 'object' || paymentError === null || !('message' in paymentError)) {
    return undefined
  }
  const message = (paymentError as {message?: unknown}).message
  return typeof message === 'string' && message.length > 0 ? message : undefined
}

export const payCycleError = (error: ErrorLike): PayCycleError => {
  const status = error.response?.status
  if (status === 402) {
    const detail = providerMessage(error.response?.data)
    return detail ? {key: 'paymentFailed', detail} : {key: 'paymentFailed'}
  }
  if (status === 409) {
    return {key: 'no_cycle_to_pay'}
  }
  return {key: 'somethingWentWrong'}
}

// While Opn's charge op is DEGRADED a 402 gets the retry hint instead of the provider's own text.
export const formatPayCycleError = (
  l: (scope: TranslatorScope) => string,
  error: ErrorLike,
  isChargeDegraded = false,
): string => {
  const {key, detail} = payCycleError(error)
  if (isChargeDegraded && key !== 'no_cycle_to_pay') {
    return `${l(key)} ${l('checkout-charge-retry-hint')}`
  }
  return detail ? `${l(key)}: ${detail}` : l(key)
}
